<template>
	<div class="sticky top-0 z-25 md:relative lg:static lg:z-auto">
		<header>
			<!-- For Desktop -->
			<div class="header-desktop hidden lg:block">
				<LayoutHeaderDesktop
					v-if="appStore.headerLoaded && isDesktop"
					:top-navbar-left="appStore.topNavbarLeft"
					:cultures-norce="appStore.culturesNorce"
					:currencies-norce="appStore.currenciesNorce"
					:search="appStore.search"
					:site-logo="appStore.siteLogo"
					:site-logo-dimensions="appStore.siteLogoDimensions"
					:menu-categories-norce="appStore.menuCategoriesNorce"
					:menu-categories="appStore.menuCategories"
					:menu="appStore.menu"
					:top-bar-items="appStore.topBarItems || []"
				/>
			</div>
			<!-- For Mobile -->
			<div class="header-mobile block lg:hidden">
				<LayoutHeaderMobile
					v-if="appStore.headerLoaded && isMobile"
					:top-navbar-left="appStore.topNavbarLeft"
					:cultures-norce="appStore.culturesNorce"
					:currencies-norce="appStore.currenciesNorce"
					:search="appStore.search"
					:site-logo="appStore.siteLogo"
					:site-logo-dimensions="appStore.siteLogoDimensions"
					:menu-categories-norce="appStore.menuCategoriesNorce"
					:menu-categories="appStore.menuCategories"
					:menu="appStore.menu"
					:top-bar-items="appStore.topBarItems || []"
				/>
			</div>
			<!-- Loading Spinner -->
			<div v-if="!appStore.headerLoaded" class="loader"></div>
		</header>
		<CartAddedPopup />
	</div>
</template>

<script setup lang="ts">
import { watch } from "vue";

const cartStore = useCartStore();
const appStore = useAppStore();
const { isMobile, isDesktop } = useBreakpoints();

watch(
	() => cartStore.cartId,
	(newCartId) => {
		if (newCartId) {
			cartStore.initCart();
		}
	},
	{ immediate: true }
);

watch(
	() => cartStore.updated,
	(newUpdated) => {
		if (newUpdated) {
			cartStore.initCart();
		}
	},
	{ immediate: true }
);
</script>
